import { render } from "./BrandSnippet.vue?vue&type=template&id=3e081164"
import script from "./BrandSnippet.vue?vue&type=script&lang=js"
export * from "./BrandSnippet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__